import { Typography } from 'libs/ui';

import { HeaderStyled } from './Header.styles';

interface Props {
  title: string;
}

export const Header = ({ title }: Props) => (
  <HeaderStyled
    alignItems="center"
    direction="row"
    justifyContent="space-between"
  >
    <Typography variant="headline">{title}</Typography>
  </HeaderStyled>
);
